import Alignment from './Alignment';

export default Alignment;
